var $ = jQuery.noConflict();

$(document).ready(function() {
  /*------------setup de la map------------*/

  let map = L.map('map', {
    gestureHandling: true
  });

  let osmUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';

  let osmAttrib = 'Map data © OpenStreetMap contributors';

  let osm = new L.TileLayer(osmUrl, {attribution: osmAttrib});

  map.setView([46.83, 1.75], 6);

  map.addLayer(osm);
  // Usage du plugin Leaflet 'markerCluster'
  const markers = L.markerClusterGroup({
    chunkedLoading: true,
    // suppression du polygone bleu au click
    polygonOptions: {
      stroke: false,
      color: 'transparent',
      opacity: 0
    },
    // suppression du polygone bleu au hover
    showCoverageOnHover: false
  });

  let data = `[{"name":"Awen Bio ","address":"Lycée agricole de Suscinio F 29 600  – Morlaix – France","latitude":"48.61958362997154","longitude":"-3.8410669137238767","tel":"02 98 72 06 95"},
              {"name":"Ferme pilote de la Durette","address":"Avignon Provence-Alpes-Côte d'Azur, France","latitude":"43.9171646","longitude":"4.8491511","tel":""},
              {"name":"Grab - Antenne de Gotheron","address":"Gotheron Auvergne-Rhône-Alpes, France","latitude":"44.9768273","longitude":"4.9212502","tel":""},
              {"name":"GRAB – Groupe de Recherche en Agriculture Biologique","address":"255 chemin de la Castelette BP 11283, F 84 911 – AVIGNON Cedex 9 – FRANCE","latitude":"43.9083541","longitude":"4.8837431","tel":"+33 (0)4 90 84 01 70"}
              ]`;

  let obj = JSON.parse(data);

  for (let i = 0; i < obj.length; i++) {
    let nom = obj[i].name;

    let lat = obj[i].latitude;

    let long = obj[i].longitude;

    let address = obj[i].address;

    let tel = obj[i].tel;

    let marker = L.marker([lat, long]);

    if (tel.length !== 0) {
      marker.bindPopup(`<b>${nom}</b><br><b>${address}</b><br><b>${tel}</b>`);
    } else {
      marker.bindPopup(`<b>${nom}</b>`);
    }

    markers.addLayer(marker);
  }

  //Affiche les markers sur la map en utilisant markerCluster
  map.addLayer(markers);

  // Event : changer le zoom par défault si je clique sur un marker en modifiant la vue de la carte
  markers.on('clusterclick', function(event) {
    map.setView(event.layer.getLatLng(), map.getZoom() + 1);
  });
});
